import { BLACK_HAT, Product, SAGE_HAT, WHITE_HAT } from '../products';

const creamCrewRecos: Product[] = [
    SAGE_HAT,
    BLACK_HAT,
    WHITE_HAT,
]; 

export default creamCrewRecos;